import React from "react";

const MarsilyaLoader = ({ label = "", compact = false }) => (
  <div className={`m-loader${compact ? " is-compact" : ""}`} role="status" aria-live="polite">
    <div className="m-loader-wheel" aria-hidden>
      <i className="m-loader-ring" />
      <i className="m-loader-ring is-late" />
      <i className="m-loader-spark" />
      <span className="m-loader-hub">
        <img src="/favicon.svg" alt="" />
      </span>
    </div>
    {label ? <em>{label}</em> : <span className="sr-only">Yükleniyor</span>}
  </div>
);

export default MarsilyaLoader;
